import React from 'react';
import Masterplan from './Masterplan';

const SitePlan = ({ t, language, onSelectLot }) => {
  const logistics = [
    { label: t.siteplan.airport, value: t.siteplan.airportDist },
    { label: t.siteplan.port, value: t.siteplan.portDist },
    { label: t.siteplan.downtown, value: t.siteplan.downtownDist }
  ];

  return (
    <section id="location" data-testid="location-section" className="py-12 sm:py-16 lg:py-20 bg-white">
      <div className="container mx-auto px-5 sm:px-6 lg:px-8 max-w-6xl">
        {/* Entrance Render */}
        <div className="mb-8 lg:mb-12 -mx-5 sm:-mx-6 lg:mx-0 overflow-hidden lg:rounded-lg">
          <img
            src="/images/renders/He_001.jpg"
            alt="Hexaparks main entrance"
            className="w-full h-[220px] sm:h-[300px] lg:h-[380px] object-cover"
          />
        </div>

        <h2 className="text-xl sm:text-2xl lg:text-3xl font-light text-gray-900 mb-8 lg:mb-12 leading-snug">
          {t.siteplan.title}
        </h2>
        
        {/* Mobile: Stacked layout */}
        <div className="lg:hidden space-y-8">
          {/* Map Image */}
          <div className="border border-gray-200">
            <img 
              src="/images/location_map.png" 
              alt="Location map"
              className="w-full h-auto"
            />
          </div>
          
          {/* Logistics Info */}
          <div>
            <h3 className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-4">
              {t.siteplan.corridors}
            </h3>
            <div className="space-y-2 text-sm text-gray-700 mb-6">
              <p>{t.siteplan.corridor1}</p>
              <p>{t.siteplan.corridor2}</p>
            </div>

            <h3 className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-4">
              {t.siteplan.proximity}
            </h3>
            <div className="space-y-3 mb-8">
              {logistics.map((item, i) => (
                <div key={i} className="flex justify-between items-baseline py-2 border-b border-gray-100">
                  <span className="text-sm text-gray-700">{item.label}</span>
                  <span className="text-sm text-gray-500">{item.value}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Site Plan section with header */}
          <div>
            <h3 className="text-lg font-light text-gray-900 mb-4">
              {t.masterplan.sitePlanTitle}
            </h3>
            <Masterplan t={t} language={language} onSelectLot={onSelectLot} />
          </div>
        </div>

        {/* Desktop: Side by side */}
        <div className="hidden lg:grid lg:grid-cols-12 lg:gap-10">
          {/* Left: Info */}
          <div className="lg:col-span-4">
            <h3 className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-4">
              {t.siteplan.corridors}
            </h3>
            <div className="space-y-2 text-sm text-gray-700 mb-8">
              <p>{t.siteplan.corridor1}</p>
              <p>{t.siteplan.corridor2}</p>
            </div>

            <h3 className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-4">
              {t.siteplan.proximity}
            </h3>
            <div className="space-y-3">
              {logistics.map((item, i) => (
                <div key={i} className="flex justify-between items-baseline py-2.5 border-b border-gray-100">
                  <span className="text-sm text-gray-700">{item.label}</span>
                  <span className="text-sm text-gray-500">{item.value}</span>
                </div>
              ))}
            </div>
          </div>
          
          {/* Right: Maps */}
          <div className="lg:col-span-8 space-y-8">
            <div className="border border-gray-200">
              <img 
                src="/images/location_map.png" 
                alt="Location map"
                className="w-full h-auto"
              />
            </div>
            
            {/* Site Plan section */}
            <div>
              <h3 className="text-xl font-light text-gray-900 mb-4">
                {t.masterplan.sitePlanTitle}
              </h3>
              <Masterplan t={t} language={language} onSelectLot={onSelectLot} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SitePlan;
